<template>
  <global-widget-banner
    v-if="globalWidget.type === GLOBAL_WIDGET_TYPES.BANNER && !isDismissed"
    :class="globalWidget.class"
    :style="globalWidget.backgroundStyle"
    :width-style="globalWidget.style"
    :global-widget-blocks="globalWidget?.globalWidgetBlocks?.data"
    :dark-mode="darkMode"
    :is-dismissable="globalWidget.config.isDismissable"
    :is-full-width="globalWidget.config.widthMode === WIDTH_MODE_OPTIONS.FULL_WIDTH"
    :is-editing="isEditing"
    :dense="globalWidget.config.denseLayout"
    :animated="globalWidget.config.animated"
    @dismiss="dismiss"
    @time-travel="$emit('time-travel')"
    @edit-global-widget-style="$emit('edit-global-widget-style')"
    @edit-site-css="$emit('edit-site-css')"
  />
  <global-widget-footer
    v-if="globalWidget.type === GLOBAL_WIDGET_TYPES.FOOTER"
    :class="globalWidget.class"
    :style="globalWidget.backgroundStyle"
    :width-style="globalWidget.style"
    :show-circuit-name="globalWidget.config.footerShowCircuitName"
    :vertical-align="globalWidget.config.footerVerticalAlignment"
    :horizontal-align="globalWidget.config.footerHorizontalAlignment"
    :horizontal-align-mobile="globalWidget.config.footerHorizontalMobileAlignment"
    :global-widget-blocks="globalWidget?.globalWidgetBlocks?.data"
    :footer-dark-mode="darkMode"
    :is-mobile-view="$q.screen.lt.md"
    :is-editing="isEditing"
    @edit-navigations="$emit('edit-navigations')"
    @time-travel="$emit('time-travel')"
    @edit-global-widget-style="$emit('edit-global-widget-style')"
    @edit-site-css="$emit('edit-site-css')"
  />
</template>

<script>
import { Cookies } from 'quasar'
import GlobalWidget, { GLOBAL_WIDGET_TYPES, RESTORATION_FREQUENCY_OPTIONS, WIDTH_MODE_OPTIONS } from 'src/models/global-widget/GlobalWidget'
import { defineAsyncComponent } from 'vue'
function globalWidgetDismissedCookie (globalWidget) {
  return `globalWidget${globalWidget.id}Dismissed`
}

function setGlobalWidgetDismissed (globalWidget) {
  if (globalWidget.config.restorationFrequency === RESTORATION_FREQUENCY_OPTIONS.EVERY_DAY) {
    Cookies.set(globalWidgetDismissedCookie(globalWidget), { expires: 1 })
  } else if (globalWidget.config.restorationFrequency === RESTORATION_FREQUENCY_OPTIONS.EVERY_WEEK) {
    Cookies.set(globalWidgetDismissedCookie(globalWidget), { expires: 7 })
  } else if (globalWidget.config.restorationFrequency === RESTORATION_FREQUENCY_OPTIONS.EVERY_MONTH) {
    Cookies.set(globalWidgetDismissedCookie(globalWidget), { expires: 30 })
  } else if (globalWidget.config.restorationFrequency === RESTORATION_FREQUENCY_OPTIONS.EVERY_YEAR) {
    Cookies.set(globalWidgetDismissedCookie(globalWidget), { expires: 365 })
  } else {
    Cookies.set(globalWidgetDismissedCookie(globalWidget), { expires: -1 })
  }
}

function isGlobalWidgetDismissed (globalWidget) {
  return Cookies.has(globalWidgetDismissedCookie(globalWidget))
}

export default {
  name: 'GlobalWidget',
  components: {
    GlobalWidgetBanner: defineAsyncComponent(() => import('src/modules/consumer/components/global-widget/GlobalWidgetBanner')),
    GlobalWidgetFooter: defineAsyncComponent(() => import('src/modules/consumer/components/global-widget/GlobalWidgetFooter'))
  },
  configuration: ['currentSite'],
  props: {
    globalWidget: {
      type: GlobalWidget,
      required: true
    },
    isEditing: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['sync', 'edit-global-widget-style', 'edit-navigations', 'time-travel', 'edit-site-css'],
  data (props) {
    return {
      isDismissed: isGlobalWidgetDismissed(props.globalWidget)
    }
  },
  computed: {
    darkMode () {
      if (!this.globalWidget.config.backgroundColor) return this.$isColorDark(this.currentSite.backgroundColor)

      if (this.globalWidget.config.backgroundColor === 'custom') return this.$isColorDark(this.globalWidget.config.backgroundColorHex)

      return this.$isColorDark(this.$getSiteColorHex(this.currentSite, this.globalWidget.config.backgroundColor))
    }
  },
  created () {
    _.extend(this, { GLOBAL_WIDGET_TYPES, WIDTH_MODE_OPTIONS })
  },
  methods: {
    dismiss () {
      this.isDismissed = true

      if (this.isEditing) return

      setGlobalWidgetDismissed(this.globalWidget)
      this.$emit('sync')
    },
    syncDismissedState () {
      this.isDismissed = isGlobalWidgetDismissed(this.globalWidget)
    }
  }
}
</script>
